<script setup lang="ts">
const { getFormattedPrice, currencyLocale, currencyCode } = usePrice();
const props = defineProps<{
  value: number | undefined;
}>();

const getPrice = computed<string>(() => getFormattedPrice(props.value));

</script>

<template>
  <p class="price">
    <slot name="beforePrice" />
    <client-only>
    <span>{{ getPrice }}</span>
    </client-only>
    <slot name="afterPrice" />
  </p>
</template>
